import {AbstractEvent} from "@/modules/base/events";
import {Team} from "@/modules/team/entity";

export class AfterTeamCreatedEvent extends AbstractEvent {
  constructor(
    public team: Team,
  ) {
    super();
  }
}